module.exports = __webpack_public_path__ + "img/ANTENNA 1 GREEN.a6a2691.svg";